import { render, staticRenderFns } from "./AgentChat.vue?vue&type=template&id=29117d34&scoped=true&"
import script from "./agent-chat.ts?vue&type=script&lang=ts&"
export * from "./agent-chat.ts?vue&type=script&lang=ts&"
import style0 from "./AgentChat.vue?vue&type=style&index=0&id=29117d34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29117d34",
  null
  
)

export default component.exports